import React from 'react';

import createIcon from './Icon';

export default createIcon(
  '0 0 24 24',
  <g>
    <path d="M8,5.14V19.14L19,12.14L8,5.14Z" />
  </g>,
);
